import React from "react";
import { useEffect } from "react";
export default function Contact() {
  useEffect(() => {
    document.title = "Contact Us";
  }, []);
  const breadcrumbItems = [
    {
      label: (
        <>
          <i className="bi bi-house"></i> Home
        </>
      ),
      link: "/",
    },
    {
      label: "Contact Us",
      link: "/contact",
    },
  ];
  return (
    <div className="contact-modern-page">
      {/* HERO */}
      <section className="contact-hero">
        <div className="contact-hero-content">
          <h1>Get In Touch</h1>
          <p>
            We're here to help with embroidery designs, membership, downloads,
            and technical support.
          </p>
        </div>
      </section>

      {/* CONTACT CARDS */}

      <section className="contact-info-section">
        <div className="contact-grid">
          {/* DIRECT SUPPORT */}

          <div className="contact-card">
            <div className="contact-icon">
              <i className="bi bi-person-lines-fill"></i>
            </div>

            <h3>Direct Support</h3>

            <div className="contact-item">
              <span>Haresh H. Vaddoriya</span>
              <a href="tel:+919879196990">+91 98791 96990</a>
            </div>

            <div className="contact-item">
              <span>Hitesh H. Vaddoriya</span>
              <a href="tel:+919909614445">+91 99096 14445</a>
            </div>
          </div>

          {/* CUSTOMER CARE */}

          <div className="contact-card">
            <div className="contact-icon">
              <i className="bi bi-headset"></i>
            </div>

            <h3>Customer Care</h3>

            <a href="tel:+918980995007" className="contact-link">
              +91 89809 95007
            </a>
          </div>

          {/* EMAIL */}

          <div className="contact-card">
            <div className="contact-icon">
              <i className="bi bi-envelope-fill"></i>
            </div>

            <h3>Email Us</h3>

            <a
              href="mailto:lifetime.ltc0777@gmail.com"
              className="contact-link"
            >
              lifetime.ltc0777@gmail.com
            </a>

            <a href="mailto:hareshvaddoriya@gmail.com" className="contact-link">
              hareshvaddoriya@gmail.com
            </a>
          </div>

          {/* ADDRESS */}

          <div className="contact-card">
            <div className="contact-icon">
              <i className="bi bi-geo-alt-fill"></i>
            </div>

            <h3>Office Address</h3>

            <p>
              Shop-17, UP GR Floor, <br />
              Ranuja Complex, <br />
              Nr- Riddhi Siddhi School,
              <br /> Vallabhacharya Road, Ashvani Kumar, <br />
              Surat-395008 Gujarat, India
            </p>
          </div>
        </div>
      </section>

      {/* MAP */}

      <section className="map-section">
        <iframe
          title="Google Map"
          src="https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d3719.337554905448!2d72.85131287526185!3d21.21845908047887!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMjHCsDEzJzA2LjUiTiA3MsKwNTEnMTQuMCJF!5e0!3m2!1sen!2sin!4v1782717357041!5m2!1sen!2sin"
          width="100%"
          height="350"
          style={{ border: 0 }}
          loading="lazy"
        ></iframe>

        <div style={{ textAlign: "center", marginTop: "15px" }}>
          <a
            href="https://maps.google.com/?q=21.218459,72.853890"
            target="_blank"
            rel="noopener noreferrer"
            className="btn btn-primary"
          >
            Open in Google Maps
          </a>
        </div>
      </section>
    </div>
  );
}
